import { useUpdate } from "../../hooks/useUpdate";

export const ChangePasswordAdmin = async (payload) => {
  try {
    return await useUpdate(
      `${process.env.REACT_APP_API_URL}/users/admin/temp/password`,
      payload
    );
  } catch (err) {
    if (err.response) return err.response;
    if (err.request) return err.request;
    if (err) return err.message;
  }
};
